import { Typography } from "@mui/material";
import { green, grey, red } from "@mui/material/colors";
import { LogiCtrlButtons } from "./Buttons";
import { LogiCtrlError } from "./Error";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const defaultRule = { id: -1, project: -1, kind: null, opening: null, subtype: null, hardwareGroupItem: null, div10Item: null, miscProduct: null, inventoryRequest: null, action: null };
export function filterStatuses(statuses, filter) { return statuses.filter(s => { if (filter.kind) {
    if (filter.kind !== s.kind)
        return false;
} if (filter.opening) {
    if (filter.opening !== s.opening)
        return false;
} if (filter.subtype) {
    if (filter.subtype !== s.subtype)
        return false;
} if (filter.hardwareGroupItem) {
    if (filter.hardwareGroupItem !== s.hardwareGroupItem)
        return false;
} if (filter.div10Item) {
    if (filter.div10Item !== s.div10)
        return false;
} return true; }); }
export function getSubItems(kind, statuses, filter) {
    if (kind === "door") {
        const hasActive = filterStatuses(statuses, filter).some(s => s.subtype === "active");
        const hasInactive = filterStatuses(statuses, filter).some(s => {
            if (s.subtype !== "inactive")
                return false;
            if (!!s.detailJson.items)
                return true; // include adding items
            if (!!s.detailJson.remove && !!s.error)
                return true; // include errored removals
            return false;
        });
        const list = [];
        if (hasActive) {
            list.push({ label: "Active", ruleFilter: { subtype: "active" } });
        }
        if (hasInactive) {
            list.push({ label: "Inactive", ruleFilter: { subtype: "inactive" } });
        }
        if (list.length === 0)
            return null;
        return list;
    }
    if (kind === "hardware") {
        const hwStatuses = statuses.filter(s => s.kind === "hardware" && s.displayName);
        const seen = new Set();
        const items = [];
        for (const s of hwStatuses) {
            const key = s.displayName;
            if (seen.has(key))
                continue;
            seen.add(key);
            if (!s.hardwareGroupItem)
                throw new Error("missing hardware group item for item");
            items.push({ label: key, ruleFilter: Object.assign(Object.assign({}, filter), { hardwareGroupItem: s.hardwareGroupItem }) });
        }
        return items.length > 0 ? items : null;
    }
    return null;
}
export function hasSubItems(kind) { return kind === "door" || kind === "hardware"; }
export function LogiCtrlSubItems(props) { const items = getSubItems(props.kind, props.statuses, props.filter); if (!items || items.length === 0)
    return null; return /*#__PURE__*/ _jsx("div", { style: { paddingLeft: 12, borderLeft: `2px solid ${grey["300"]}`, marginLeft: 4, marginTop: 4, display: "flex", flexDirection: "column", gap: 4 }, children: items.map((item, i) => /*#__PURE__*/ _jsx(SubItemRow, { label: item.label, filter: Object.assign(Object.assign({}, props.filter), item.ruleFilter), inherited: props.inherited, rules: props.rules, statuses: props.statuses, onRuleChange: props.onRuleChange }, i)) }); }
export function SubItemRow(props) { var _status$find; const existing = props.rules.find(r => { for (const k in props.filter) {
    if (r[k] !== props.filter[k])
        return false;
} return true; }); const action = (existing === null || existing === void 0 ? void 0 : existing.action) || null; const setAction = value => { if (existing) {
    props.onRuleChange(existing, Object.assign(Object.assign({}, existing), { action: value }));
    return;
} props.onRuleChange(null, Object.assign(Object.assign(Object.assign({}, defaultRule), props.filter), { id: -1, action: value })); }; const status = filterStatuses(props.statuses, props.filter); const error = (_status$find = status.find(s => !!s.error)) === null || _status$find === void 0 ? void 0 : _status$find.error; return /*#__PURE__*/ _jsxs(_Fragment, { children: [/*#__PURE__*/ _jsxs("div", { style: { display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8 }, children: [/*#__PURE__*/ _jsx(Typography, { variant: "body2", sx: { fontSize: 12, color: "text.secondary" }, children: props.label }), /*#__PURE__*/ _jsxs("div", { style: { display: "flex", alignItems: "center", gap: 4 }, children: [/*#__PURE__*/ _jsx("div", { style: { width: 8, height: 8, borderRadius: "50%", backgroundColor: !!error ? red["600"] : green["600"], marginRight: 8 } }), /*#__PURE__*/ _jsx(LogiCtrlButtons, { value: action, onChange: setAction, inherited: props.inherited })] })] }), !!error && /*#__PURE__*/ _jsx(LogiCtrlError, { error: error })] }); }
